module.exports = __webpack_public_path__ + "img/icon-node-open.7813e98d.svg";